
class AddOnAdjuster {
	static moveAddOns(fulfillmentDetails){
		try{
			const ac = document.querySelector('#add-on__container');
			let atc = document.querySelector('.add-ons__wrapper');
			if(ac && atc){
				atc.appendChild(ac);
				setTimeout(()=>{
					let sthTileSelected = document.querySelectorAll('.shippingTile.card-selected.card-enabled');
					_enableDisableInstallationAddOn(sthTileSelected.length > 0);
				}, 1000);
			}
			if(ac){
				setTimeout(()=>{
					swapMultiAddOnLeftRight();
					restyleHDPP(fulfillmentDetails.inStoreAssemblyAvailable);
					restyleInstallations();
					restyleInHomeInstallations();
					restyleInHomeAssembly();
					restyleMultipleAddOnMessagesPresent(fulfillmentDetails.isAssemblyEligible, fulfillmentDetails.inStoreAssemblyAvailable);
				}, 100)
			}
		}catch(e){
			console.error(e);
		}
	}

	static reAdjustExpertInHome(){
		try{
			const ac = document.querySelector('#add-on__container');
			// let atc = document.querySelector('.add-ons__wrapper');
			let dualPath = document.querySelector('#dual-path__checkbox');
			const bbNew = document.querySelector('#buybelt-wrapper-new');
			if(ac && dualPath && bbNew){
				bbNew.append(ac);
				ac.style["padding-top"] = "20px";
			}
		}catch(e){
			console.error(e);
		}
	}

	static enableDisableInstallationAddOn(enabled){
		return _enableDisableInstallationAddOn(enabled);
	}
}

function restyleMultipleAddOnMessagesPresent(isAssemblyEligible, inStoreAssemblyAvailable){
	try{
		const multi = document.querySelector('.multi-add-on__container');
		if(multi && (isAssemblyEligible || inStoreAssemblyAvailable)){
			document.querySelector('.multi-add-on__container').style.borderTop = "0px";
		}
	}catch(e){
		console.error(e);
	}
}

function swapMultiAddOnLeftRight(){
       try{
               const multi = document.querySelector('.multi-add-on__container');
               if(multi){
                       const left = document.querySelector('#multi-add-on-left');
                       const right = document.querySelector('#multi-add-on-right');
                       if(left && right){
							left.parentNode.appendChild(left);
							right.style.paddingLeft = "0px";
                       }
                if(window.innerWidth < 600){
					multi.style.display = 'block';
					right.style.paddingLeft = "0px";
					left.style.paddingLeft = "0px";
					left.style.paddingTop = "0px";
					left.classList.remove('col-6');
					right.classList.remove('col-6');
				}
               }
       }catch(e){
               console.error(e);
       }
}

function restyleHDPP(inStoreAssemblyAvailable){
	try{
		let hdpp = document.querySelector('#buyBox-hdpp');
		let atcDisabled =  document.querySelector('.bttn--atc.disabled');
		let multi = document.querySelector('.multi-add-on__container');
		let wrapper = document.querySelector('.add-ons__wrapper');
		let buyBoxText = document.querySelector('.buybox__add-on__optin-text');
		let assemblyWrapper = document.querySelector('.assembly__wrapper');

		if(hdpp && !atcDisabled){
			if(!multi && wrapper){
				wrapper.style.paddingBottom = "0px";
				wrapper.style.paddingTop = "0px";
				buyBoxText.style.marginBottom = "0px";
				hdpp.style.marginBottom = "20px";
			}
			hdpp = hdpp.querySelector('label');
			hdpp.classList.add('body__m-bottom-large');
			if(hdpp){
				let priceContainer = hdpp.querySelector('.buybox__add-on__price');
				let head = hdpp.querySelector('span.u__bold');
				if(priceContainer && head){
					let price = priceContainer.innerText;
					let headText = head.innerText;
					head.innerText = 'Protect This Item';
					headText = headText.replace('-yr', ' year');
					headText = headText.replace('for', ('plan / ' + price));
					priceContainer.innerText = ('\n' + headText);
					priceContainer.classList.remove('buybox__add-on__price');
				}
			}
		}else if(hdpp) {
			hdpp.classList.add('u--hide');
		}
		if (assemblyWrapper && multi) {
			assemblyWrapper.style.marginBottom = "0px";
		}
	}catch(e){
		console.error(e);
	}
}

function restyleInstallations() {
	try {
		let proReferral = document.querySelector('#buyBox-pro-referral');
		if (proReferral) {
			proReferral = proReferral.querySelector('label');
			let head = proReferral && proReferral.querySelector('span.u__bold');
			if (head) {
				head.innerText = 'Get In-Home Installation';
				head.insertAdjacentHTML('afterend', "<span><br>Powered by Pro Referral</span>");
			}
		}
	} catch (e) {
		console.error(e);
	}
}

function restyleInHomeInstallations() {
	try{
		let inHomeInstall = document.querySelector('#buyBox-attach-labor');
		if(inHomeInstall ){
			inHomeInstall =  inHomeInstall.querySelector('label');
			let head = inHomeInstall && inHomeInstall.querySelector('span.u__bold');
			if(head) {
				head.innerText = head.innerText.replace('for', ('plan /'));
				// head.innerText = `${head.innerText}.00`;
				head.insertAdjacentHTML('beforebegin', "<span class='u__bold'>Get In-Home Installation <br></span>");
				head.classList.remove('u__bold');
			}
		}
	}catch(e){
		console.error(e);
	}
}

function restyleInHomeAssembly() {
	try{
		let inHomeAssembly = document.querySelector('#buyBox-assembly');
		let learnMore = document.querySelector('.buybox__add-on__learn-more-cta');
		if(inHomeAssembly ){
			inHomeAssembly =  inHomeAssembly.querySelector('label');
			let head = inHomeAssembly && inHomeAssembly.getElementsByTagName('span');
			if(head) {
				head[0].innerText = "Need It Assembled?";
				head[1].innerText = head[1].innerText.replace('for as low as', 'Add In-Home Assembly /');
				head[1].classList.remove('u__bold');
				learnMore.innerText = 'What to Expect?';
			}
		}
	}catch(e){
		console.error(e);
	}
}

function _enableDisableInstallationAddOn(enabled=false){
	try{
		let install = document.querySelector('#attach-labor__checkbox');
		let inHomeInstall = document.querySelector('#buyBox-attach-labor');
		let additionalText = inHomeInstall.querySelector('.buybox__add-on__learn-more-cta');

		if(install){
			if(enabled){
				install.removeAttribute("disabled");
				if(inHomeInstall){
					if(additionalText){
						additionalText.style.display = "block";
						additionalText.style.cursor = "pointer";
						additionalText.removeAttribute("pointerEvents");
						additionalText.className = "buybox__add-on__learn-more-cta u__default-link";
					}
				}
			}else{
				install.setAttribute("disabled", true);
				if(inHomeInstall){
					if(additionalText){
						additionalText.style.cursor = "default";
						additionalText.style.pointerEvents = "none";
						additionalText.className = "buybox__add-on__learn-more-cta";
					}
				}
			}
		}else{
			if(isIe11()){
				setTimeout(()=>{
					try{
						if(install){
							if(enabled){
								install.removeAttribute("disabled");
								if(inHomeInstall){
									if(additionalText){
										additionalText.style.display = "block";
										additionalText.style.cursor = "pointer";
										additionalText.removeAttribute("pointerEvents");
										additionalText.className = "buybox__add-on__learn-more-cta u__default-link";
									}
								}
							}else{
								install.setAttribute("disabled", true);
								if(inHomeInstall){
									if(additionalText){
										additionalText.style.cursor = "default";
										additionalText.style.pointerEvents = "none";
										additionalText.className = "buybox__add-on__learn-more-cta";
									}
								}
							}
						}
					}catch(e){
						console.error(e);
					}
				}, 5000)
			}
		}

		let assembly = document.querySelector('#assembly__checkbox');
		if (assembly) {
			enabled ? assembly.removeAttribute("disabled") : assembly.setAttribute("disabled", true);
		}
	}catch(e){
		console.error(e);
	}
}

function isIe11(){
	try{
	  return (!!window.MSInputMethodContext && !!document.documentMode);
	}catch(e){
	  console.error(e);
	}
}

export default AddOnAdjuster;
